import React, { Component } from 'react';
import { translate } from 'react-i18next';

// Functions
import { startDayWithUtc } from 'services/date';

// Components
import SelectField from 'src/components/Fields/SelectFields/SelectField';
import DatePicker from 'src/components/DataPicker';

// Styles
import rfStyles from './styles';

class ReportFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.data
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.sendOnChangeData = this.sendOnChangeData.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props;
    if (data && JSON.stringify(prevProps.data) !== JSON.stringify(data)) {
      this.setState({ ...data }, () => {
        this.sendOnChangeData();
      });
    }
  }

  handleDateChange(newDate) {
    this.setState({ startDate: newDate });
  }

  handleChangeData(target, value, optionName = 'value') {
    const obj = Object.assign({}, this.state[target]);
    obj[optionName] = value;
    this.setState({ [target]: obj }, () => {
      this.sendOnChangeData();
    });
  }

  sendOnChangeData() {
    const { onChange } = this.props;
    const keys = Object.keys(this.state);
    const returnData = {};

    keys.forEach(key => {
      const valueField = this.state[key]['valueField'];
      const targetType = this.state[key]['elementType'];
      if (this.state[key] && valueField) {
        returnData[key] =
          (this.state[key]['value'] && this.state[key]['value'][valueField]) ||
          (this.state[key]['defaultValue'] && this.state[key]['defaultValue'][valueField]);
      } else if (targetType && targetType === 'datePiker') {
        returnData[key] = startDayWithUtc(this.state[key]['selected']);
      } else {
        returnData[key] = this.state[key]['value'] || this.state[key]['defaultValue'];
      }
    });

    if (onChange) {
      onChange(returnData);
    }
  }

  render() {
    const { i18n } = this.props;
    const { reportType, practitioners, locations, date } = this.state;
    const isHaveAllData = reportType && practitioners && locations && date;

    return isHaveAllData ? (
      <rfStyles.RF_Wrapper>
        <div>
          <SelectField
            {...reportType}
            label={i18n.t(reportType.translateLabelKey)}
            onChange={val => {
              this.handleChangeData('reportType', val);
            }}
          />
        </div>
        <div>
          <SelectField
            {...practitioners}
            label={i18n.t(practitioners.translateLabelKey)}
            onChange={val => {
              this.handleChangeData('practitioners', val);
            }}
          />
        </div>
        <div>
          <SelectField
            {...locations}
            label={i18n.t(locations.translateLabelKey)}
            onChange={val => {
              this.handleChangeData('locations', val);
            }}
          />
        </div>
        <div>
          <DatePicker
            {...date}
            label={i18n.t(date.translateLabelKey)}
            onChange={val => {
              this.handleChangeData('date', val, 'selected');
            }}
          />
        </div>
      </rfStyles.RF_Wrapper>
    ) : null;
  }
}

export default translate()(ReportFilters);
